import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonAPIService, CommonService, SharedService, ToasterService } from '../../../../services';

@Component({
  selector: 'app-apply-course',
  standalone: false,
  templateUrl: './apply-course.component.html',
  styleUrl: './apply-course.component.scss'
})
export class ApplyCourseComponent {
  @Input() course: any;
  inquiryForm!: FormGroup;
  isSuccessPopup = false;
  successMessage = 'Inquiry submitted successfully!';

  constructor(
    private activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private sharedService: SharedService,
    private commonService: CommonService,
    private toasterService: ToasterService,
    private commonAPIService: CommonAPIService,) {
    this.inquiryForm = this.fb.group({
      name: ['', Validators.required],
      contactNo: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      email: ['', [Validators.required, Validators.email]],
      inquiryDescription: ['', Validators.required]
    });
  }

  ngOnInit() {
  }

  close() {
    this.activeModal.close();
  }

  async submitInquiry() {
    if (this.inquiryForm.valid) {
      const body: any = {
        coursesId: this.course.coursesId,
        email: this.inquiryForm.get("email")?.value,
        notes: this.inquiryForm.get("name")?.value,
        contactNo: this.inquiryForm.get("contactNo")?.value,
        inquiryDescription: this.inquiryForm.get("inquiryDescription")?.value,
      };
      try {
        this.sharedService.setApiCall(true);
        this.commonService.resetAPIFlag('coursesinquiry', false);
        const response = await this.commonAPIService.postCall('coursesinquiry', body);
        this.commonService.resetAPIFlag('coursesinquiry', false);
        switch (response.status) {
          case 1:
            this.sharedService.setApiCall(false);
            this.isSuccessPopup = true;
            setTimeout(() => {
              this.isSuccessPopup = false;
              this.close();
            }, 2000);
            // this.toasterService.toastSuccess(response.message);
            break;
          case 0:
            // this.toasterService.toastError(response.message);
            break;
        }
      } catch (error) {
        console.error('API Error:', error);
        this.toasterService.toastError('Something went wrong.');
      }
    }
  }
}
